<div class="support-user-text mx-2 p-2 text-center text-success"
[matTooltip]="supportUserDetailsMessage" matTooltipPosition="right" matTooltipClass="mat-tooltip-multiline"
[routerLink]="['/settings/organisation-settings/details']" [queryParams]="{supportUserClicked: true}"
*ngIf="supportUserDetails.isSupportEnabled">
    <mat-icon>group</mat-icon>
    <span *ngIf="sidenavExpanded">Support user enabled</span>
</div>
